var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutoStop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 420.8 420.8",
    style: {
      enableBackground: "new 0 0 420.8 420.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;opacity:0.18;}\n\t.st2{fill:none;}\n\t.st3{display:inline;fill:none;}\n\t.st4{fill:#EEE045;}\n\t.st5{fill:#1C2D6B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_3_\\uC0AC\\uBCF8",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M210.4,352.5c-78.4,0-142.1-63.8-142.1-142.1C68.3,132,132,68.3,210.4,68.3c78.4,0,142.1,63.8,142.1,142.1 C352.5,288.8,288.8,352.5,210.4,352.5z M210.4,77.3C137,77.3,77.3,137,77.3,210.4S137,343.5,210.4,343.5s133.1-59.7,133.1-133.1 S283.8,77.3,210.4,77.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st2",
    d: "M205.9,111.8c-52.3,2.4-94.2,45.7-94.2,98.6c0,25.6,9.8,49,25.8,66.5l68.4-68.4V111.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st2",
    d: "M143.9,283.3c17.6,16,40.9,25.8,66.5,25.8c54.4,0,98.7-44.3,98.7-98.7c0-52.9-41.9-96.2-94.2-98.6v100.5 L143.9,283.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M214.9,102.8v9c52.3,2.4,94.2,45.7,94.2,98.6c0,54.4-44.3,98.7-98.7,98.7c-25.6,0-49-9.8-66.5-25.8l-6.4,6.4 c19.2,17.7,44.8,28.5,72.9,28.5c59.4,0,107.7-48.3,107.7-107.7C318.1,152.5,272.2,105.2,214.9,102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M205.9,111.8v96.7l-68.4,68.4c2,2.2,4.1,4.3,6.4,6.4l71-71V111.8c-1.5-0.1-3-0.1-4.5-0.1 C208.9,111.7,207.4,111.7,205.9,111.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M137.5,276.9l-6.4,6.4c2,2.2,4.2,4.3,6.4,6.4l6.4-6.4C141.7,281.2,139.6,279.1,137.5,276.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M210.4,111.7c1.5,0,3,0,4.5,0.1v-9c-1.5-0.1-3-0.1-4.5-0.1c-1.5,0-3,0-4.5,0.1v9C207.4,111.7,208.9,111.7,210.4,111.7z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st4",
    d: "M323.2,216.1L323.2,216.1L323.2,216.1L323.2,216.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st2",
    d: "M264.5,320.6l0-11.4c0-8.4,3.1-16.4,8.4-22.7v-32.8c-5.3-6.2-8.4-14.3-8.4-22.7v-11.4 c-4.9-1.7-8.4-6.4-8.4-11.9c0-7,5.7-12.6,12.6-12.6h4.2V87c0-1.5-1.3-2.8-2.8-2.8H90.5c-1.5,0-2.8,1.3-2.8,2.8v246.9 c0,1.5,1.3,2.8,2.8,2.8h166.3c-0.5-1.3-0.7-2.7-0.7-4.2C256.1,327,259.6,322.3,264.5,320.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st2",
    d: "M264.5,207.6c0,2.3,1.9,4.2,4.2,4.2c0,0,0,0,0,0h4.2v-8.4h-4.2C266.4,203.4,264.5,205.3,264.5,207.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st2",
    d: "M281.3,333.8c0,1-0.1,1.9-0.4,2.8h71.9c2.3,0,4.2-1.9,4.2-4.2c0-2.3-1.9-4.2-4.2-4.2h0h-71.5V333.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st2",
    d: "M272.9,333.8v-5.6h-4.2c-2.3,0-4.2,1.9-4.2,4.2c0,2.3,1.9,4.2,4.2,4.2h1.4 C271.6,336.6,272.9,335.4,272.9,333.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st2",
    d: "M292.8,272.4c1.2-0.7,1.4-1.9,1.4-2.4c0-0.5-0.1-1.7-1.4-2.4l-11.4-6.8c0,0,0,0-0.1,0v18.6c0,0,0,0,0.1,0 L292.8,272.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st2",
    d: "M352.9,211.8C352.9,211.8,352.9,211.8,352.9,211.8c2.3,0,4.2-1.9,4.2-4.2c0-2.3-1.9-4.2-4.2-4.2h-71.5v8.4 H352.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st2",
    d: "M285.7,253.6l11.4,6.8c3.4,2,5.4,5.6,5.4,9.6c0,4-2,7.6-5.4,9.6l-11.4,6.8c-1.6,1-3.1,2.1-4.4,3.3v30h67.3 v-10.7c0-9.2-4.9-17.9-12.8-22.6l-11.4-6.8c-3.4-2-5.4-5.6-5.4-9.6c0-4,2-7.6,5.4-9.6l11.4-6.8c7.9-4.7,12.8-13.4,12.8-22.6v-10.7 h-67.3v30C282.7,251.5,284.1,252.6,285.7,253.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st2",
    d: "M272.9,319.8L272.9,319.8l0-10.8c0,0,0,0.1,0,0.1L272.9,319.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M256.8,336.6H90.5c-1.5,0-2.8-1.3-2.8-2.8V87c0-1.5,1.3-2.8,2.8-2.8h179.6c1.5,0,2.8,1.3,2.8,2.8V195h8.4V87 c0-6.2-5-11.2-11.2-11.2H90.5c-6.2,0-11.2,5-11.2,11.2v246.9c0,6.2,5,11.2,11.2,11.2h178.1C263.2,345.1,258.5,341.5,256.8,336.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M281.3,279.3v-18.6c-3.2-1.9-6-4.4-8.4-7.1v32.8C275.3,283.7,278.1,281.3,281.3,279.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st5",
    d: "M272.9,211.9L272.9,211.9l-4.2,0c0,0,0,0,0,0c0,0,0,0,0,0H272.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st5",
    d: "M281.3,211.8L281.3,211.8l71.5,0c0,0,0,0,0,0c0,0,0,0,0,0H281.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.9,
    y: 211.8,
    className: "st5",
    width: 8.4,
    height: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.9,
    y: 220.3,
    className: "st5",
    width: 8.4,
    height: 0
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M357.1,320.6v-11.4c0-12.2-6.5-23.6-16.9-29.8l-11.4-6.8c-1.2-0.7-1.4-1.9-1.4-2.4c0-0.5,0.1-1.7,1.4-2.4l11.4-6.8 c10.4-6.3,16.9-17.7,16.9-29.8v-11.4c4.9-1.7,8.4-6.4,8.4-11.9c0-7-5.7-12.6-12.6-12.6h-71.5h-8.4h-4.2c-7,0-12.6,5.7-12.6,12.6 c0,5.5,3.5,10.2,8.4,11.9V231c0,8.4,3.1,16.4,8.4,22.7c2.4,2.8,5.2,5.2,8.4,7.1c0,0,0,0,0.1,0l11.4,6.8c1.2,0.7,1.4,1.9,1.4,2.4 c0,0.5-0.1,1.7-1.4,2.4l-11.4,6.8c0,0,0,0-0.1,0c-3.2,1.9-6,4.4-8.4,7.1c-5.3,6.2-8.4,14.3-8.4,22.7l0,11.4 c-4.9,1.7-8.4,6.4-8.4,11.9c0,1.5,0.3,2.9,0.7,4.2c1.7,4.9,6.4,8.4,11.9,8.4h1.4h82.8c7,0,12.6-5.7,12.6-12.6 C365.5,327,362,322.3,357.1,320.6z M268.7,211.9C268.7,211.9,268.7,211.8,268.7,211.9c-2.3,0-4.2-1.9-4.2-4.2 c0-2.3,1.9-4.2,4.2-4.2h4.2h8.4h71.5c2.3,0,4.2,1.9,4.2,4.2c0,2.3-1.9,4.2-4.2,4.2c0,0,0,0,0,0h-71.5h-8.4H268.7z M272.9,309.1 c0,0,0-0.1,0-0.1c0-7.3,3.2-14.3,8.4-19.2c1.3-1.2,2.8-2.4,4.4-3.3l11.4-6.8c3.4-2,5.4-5.6,5.4-9.6c0-4-2-7.6-5.4-9.6l-11.4-6.8 c-1.6-1-3.1-2.1-4.4-3.3c-5.3-4.9-8.4-11.9-8.4-19.3v-10.7v0h8.4v0h67.3V231c0,9.2-4.9,17.9-12.8,22.6l-11.4,6.8 c-3.4,2-5.4,5.6-5.4,9.6c0,4,2,7.6,5.4,9.6l11.4,6.8c7.9,4.7,12.8,13.4,12.8,22.6v10.7h-67.3h-8.4h0L272.9,309.1z M352.9,336.6 h-71.9h-10.9h-1.4c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2h4.2h8.4h71.5h0c2.3,0,4.2,1.9,4.2,4.2 C357.1,334.8,355.2,336.6,352.9,336.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M243.4,134.7h-75.7c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2h75.7c2.3,0,4.2,1.9,4.2,4.2 C247.7,132.8,245.8,134.7,243.4,134.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M243.4,159.9h-75.7c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2h75.7c2.3,0,4.2,1.9,4.2,4.2S245.8,159.9,243.4,159.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M243.4,202h-75.7c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2h75.7c2.3,0,4.2,1.9,4.2,4.2 C247.7,200.1,245.8,202,243.4,202z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M243.4,227.2h-75.7c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2h75.7c2.3,0,4.2,1.9,4.2,4.2 C247.7,225.3,245.8,227.2,243.4,227.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M243.4,269.3h-75.7c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2h75.7c2.3,0,4.2,1.9,4.2,4.2S245.8,269.3,243.4,269.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M243.4,294.6h-75.7c-2.3,0-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2h75.7c2.3,0,4.2,1.9,4.2,4.2S245.8,294.6,243.4,294.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M119,151.7c0.9,0.9,2.1,1.4,3.3,1.4c1.2,0,2.4-0.5,3.3-1.4l12.7-12.7c1.8-1.8,1.8-4.8,0-6.6c-1.8-1.8-4.8-1.8-6.6,0 l-9.4,9.4l-3.1-3.1c-1.8-1.8-4.8-1.8-6.6,0c-1.8,1.8-1.8,4.8,0,6.6L119,151.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M151.7,120.7c0-2.6-2.1-4.6-4.6-4.6h-43.3c-2.6,0-4.6,2.1-4.6,4.6V164c0,2.6,2.1,4.6,4.6,4.6H147c2.6,0,4.6-2.1,4.6-4.6 V120.7z M142.4,159.3h-34v-34h34V159.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M119,219.8c0.9,0.9,2.1,1.4,3.3,1.4c1.2,0,2.4-0.5,3.3-1.4l12.7-12.7c1.8-1.8,1.8-4.8,0-6.6c-1.8-1.8-4.8-1.8-6.6,0 l-9.4,9.4l-3.1-3.1c-1.8-1.8-4.8-1.8-6.6,0c-1.8,1.8-1.8,4.8,0,6.6L119,219.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M151.7,188.8c0-2.6-2.1-4.6-4.6-4.6h-43.3c-2.6,0-4.6,2.1-4.6,4.6v43.3c0,2.6,2.1,4.6,4.6,4.6H147c2.6,0,4.6-2.1,4.6-4.6 V188.8z M142.4,227.4h-34v-34h34V227.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M119,287.9c0.9,0.9,2.1,1.4,3.3,1.4c1.2,0,2.4-0.5,3.3-1.4l12.7-12.7c1.8-1.8,1.8-4.8,0-6.6c-1.8-1.8-4.8-1.8-6.6,0 l-9.4,9.4l-3.1-3.1c-1.8-1.8-4.8-1.8-6.6,0c-1.8,1.8-1.8,4.8,0,6.6L119,287.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M151.7,256.9c0-2.6-2.1-4.6-4.6-4.6h-43.3c-2.6,0-4.6,2.1-4.6,4.6v43.3c0,2.6,2.1,4.6,4.6,4.6H147c2.6,0,4.6-2.1,4.6-4.6 V256.9z M142.4,295.6h-34v-34h34V295.6z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoStop);
export default __webpack_public_path__ + "static/media/auto-stop.47e676fe.svg";
export { ForwardRef as ReactComponent };